import React, { ReactNode } from 'react';
import { AppProps } from 'next/app';
import Error from 'next/error';
import ErrorBoundary, {
  ErrorBoundaryProvider,
} from '@narvar/nth-bit-error-boundary';
import errorCallback from '../src/lib/errorCallback';

if (process.env.NODE_ENV !== 'production' && typeof window !== 'undefined') {
  // Show a11y issues in dev tools console
  //
  // eslint-plugin-jsx-a11y does not test the final HTML output. The
  // @axe-core/react package provides a more comprehensive check.
  import('react-dom').then((ReactDOM) => {
    import('@axe-core/react').then((axe) => {
      axe.default(React, ReactDOM, 1000, {});
    });
  });
}

export default function App({ Component, pageProps }: AppProps): ReactNode {
  return (
    <ErrorBoundaryProvider handleError={errorCallback}>
      <ErrorBoundary errorContent={<Error statusCode={500} />}>
        <Component
          // eslint-disable-next-line react/jsx-props-no-spreading
          {...pageProps}
        />
      </ErrorBoundary>
    </ErrorBoundaryProvider>
  );
}
